export const commonClassesNames = {
    VALIDATION_INDETERMINATE_CLASS: "gxg-validation--indeterminate",
    VALIDATION_WARNING_CLASS: "gxg-validation--warning",
    VALIDATION_ERROR_CLASS: "gxg-validation--error",
    VALIDATION_SUCCESS_CLASS: "gxg-validation--success",
    DISABLED_CLASS: "gxg--disabled",
};
export const formClasses = {
    DISPLAY_VALIDATION_STYLES_CLASS: "gxg-display-validation-styles",
    VALIDATION_INDETERMINATE_CLASS: commonClassesNames["VALIDATION_INDETERMINATE_CLASS"],
    VALIDATION_WARNING_CLASS: commonClassesNames["VALIDATION_WARNING_CLASS"],
    VALIDATION_ERROR_CLASS: commonClassesNames["VALIDATION_ERROR_CLASS"],
    VALIDATION_SUCCESS_CLASS: commonClassesNames["VALIDATION_SUCCESS_CLASS"],
    DISABLED_CLASS: commonClassesNames["DISABLED_CLASS"],
};
//# sourceMappingURL=classesNames.js.map
